<template>
  <div
    style="scrollbar-gutter: stable"
    :style="sideFilters && { width: 'clamp(16.25rem, 25%, 22.5rem)' }"
  >
    <slot name="title" />
    <filter-display
      v-bind="{ filters, filtersQuery, currency, sideFilters }"
      class="b-b b-grey-80 py-4"
      :max-collapsed-rows="{ sm: 2, md: 1, lg: 2 }"
      @clear="$emit('clear')"
      @remove="$emit('remove', $event)"
    />
    <filter-pickup
      v-if="pickupFilters"
      class="b-b b-grey-80 py-4"
      :model-value="storeFilterState"
      @update:model-value="$emit('changeStore', $event)"
    />
    <vf-accordion v-if="sortOptions?.length" open :title="$t.sort" variant="aligned">
      <div class="f-col gap-2 pb-4">
        <vf-radio
          v-for="{ value, label } in sortOptions"
          :key="value"
          :model-value="sortState"
          name="sort"
          :value="value"
          @update:model-value="$emit('sort', $event!)"
        >
          {{ label }}
        </vf-radio>
      </div>
    </vf-accordion>
    <template v-if="Object.keys(filters)?.length">
      <vf-accordion
        v-for="(filter, code) in filters"
        :key="code"
        :title="filter.label"
        variant="aligned"
      >
        <filter-options
          v-bind="{ filter, code }"
          class="pb-4"
          :currency
          :loading
          :model-value="filters[code].selected"
          @update:model-value="$emit('change', { code: `${code}`, selected: $event! })"
        />
      </vf-accordion>
    </template>
    <product-list-skeleton v-else-if="loading" />
  </div>
</template>

<script lang="ts" setup>
import type { SortType } from '#types/config/pages/plp'
import type { FiltersMap } from '#types/filters'

defineProps<{
  sideFilters?: boolean
  currency?: string
  loading?: boolean
  filters: FiltersMap
  filtersQuery?: Record<string, string[]>
  total: number
  pickupFilters: boolean
  sortOptions?: { value: SortType, label: string }[]
  sortState?: string
  storeFilterState?: string
}>()

defineEmits<{
  clear: []
  remove: [payload: { code: string, id: string }]
  change: [payload: { code: string, selected: string[] }]
  changeStore: [payload?: string]
  sort: [payload: string]
}>()

defineSlots<{
  title: () => void
}>()
</script>
